import {
  LucideFileText,
  LucideShare,
  LucideSheet,
  LucideSquare,
} from 'lucide-react'
import { useState } from 'react'
import { aCheckedListings, useAtom } from '~/atoms'
import { Badge } from '~/components/common'
import { CreatePdfDialog } from '~/components/reports'
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/components/ui'

export default function Actions({ className }: { className?: string }) {
  const [checkedListings, setCheckedListings] = useAtom(aCheckedListings)
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={className}>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button variant="map" className="relative px-3">
            <LucideShare className="mr-2 h-4 w-4" /> Actions
            {checkedListings.length > 0 && (
              <Badge className="pointer-events-none absolute -right-1 -top-1 inline-flex h-4 items-center justify-center rounded-full bg-primary px-[5px] py-0 text-xs text-white">
                {checkedListings.length}
              </Badge>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-56 bg-background p-1"
          side="bottom"
          align="start">
          {checkedListings.length === 0 ? (
            <div className="px-2 py-2">
              <p className="text-sm">Check a listing to view options</p>
            </div>
          ) : (
            <>
              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start"
                asChild>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`/listings/multiple?ids=${checkedListings.join(',')}`}>
                  <LucideShare className="mr-2 h-5 w-5" />
                  Share Multiple Listings
                </a>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start"
                asChild>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`/export/listings.csv?ids=${checkedListings.join(',')}`}>
                  <LucideSheet className="mr-2 h-5 w-5" />
                  Export to CSV
                </a>
              </Button>
              <CreatePdfDialog listingIds={checkedListings}>
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start">
                  <LucideFileText className="mr-2 h-5 w-5" />
                  Create PDF
                </Button>
              </CreatePdfDialog>
              <div className="my-1 border-t border-border" />
              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start"
                onClick={() => {
                  setCheckedListings([])
                  setIsOpen(false)
                }}>
                <LucideSquare className="mr-2 h-5 w-5" />
                Clear Selected
              </Button>
            </>
          )}
        </PopoverContent>
      </Popover>
    </div>
  )
}
